// removed by extract-text-webpack-plugin
module.exports = {"legend_container":"legend_container__1i6qk"};


//////////////////
// WEBPACK FOOTER
// ./components/topography-icons-legend/style.scss
// module id = 5a/9
// module chunks = 0